const FAILURE_CONFIG = {
    text: 'Click here for more information',
    link: 'https://support.alternaleaf.com.au/hc/en-au/articles/10831241604367-How-consultations-work',
};
const NETWORK_LATENCY_FAILURE_CONFIG = {
    text: `It appears your internet speed is below the level needed for a high quality video consultation. Don't worry, the clinician will call your phone when they're ready.`,
    buttonConfig: [FAILURE_CONFIG],
};
const BROWSER_FAILURE_CONFIG = {
    text: `It appears you're using an unsupported browser. Please close this browser and open your consultation link using Chrome, Safari, Firefox or Edge. Alternatively, the clinician will call you on your phone when they're ready.`,
    buttonConfig: [
        {
            text: 'Click here for more information',
            link: 'https://support.alternaleaf.com.au/hc/en-au/articles/10869733610639-Technical-support#h_01J92KRHA33CKHCYKSD76SNP7W',
        },
    ],
};
const PERMISSION_FAILURE_CONFIG = {
    text: `A video consultation isn't possible this time as we can't access your microphone. Don't worry, the clinician will call your phone when they're ready.`,
    buttonConfig: [FAILURE_CONFIG],
};
const CHECK_FAILURE_CONFIG = {
    text: `A video consultation isn't possible this time. Don't worry, the clinician will call your phone when they're ready.`,
    buttonConfig: [FAILURE_CONFIG],
};
const CHECK_FAILURE_CONFIG_IC = {
    text: `A video consultation isn't possible this time. Would you like to continue with a phone call instead?`,
    buttonConfig: [
        {
            text: 'Yes, call me now',
        },
        {
            text: 'No, schedule for later',
        },
    ],
};
const MISSED_CONSULTATION_CONFIG = {
    text: `It looks like you’ve missed your scheduled consultation. Don't worry - you can easily book a new consultation at a time that works best for you.`,
    buttonConfig: [
        {
            text: 'Book a new consultation',
            link: 'https://support.alternaleaf.com.au/hc/en-au/articles/10831470544143-Managing-consultations',
        },
    ],
};
export const ConclusionPromptState = {
    NetworkLatencyFailure: NETWORK_LATENCY_FAILURE_CONFIG,
    BrowserFailure: BROWSER_FAILURE_CONFIG,
    PermissionFailure: PERMISSION_FAILURE_CONFIG,
    CheckFailure: CHECK_FAILURE_CONFIG,
    CheckFailureIc: CHECK_FAILURE_CONFIG_IC,
    MissedConsultation: MISSED_CONSULTATION_CONFIG,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29uY2x1c2lvblByb21wdC5jb25maWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9WaWRlb0NvbnN1bHRhdGlvbi9EZXZpY2VSZWFkaW5lc3MvQ29uY2x1c2lvblByb21wdC9Db25jbHVzaW9uUHJvbXB0LmNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXQSxNQUFNLGNBQWMsR0FBRztJQUNyQixJQUFJLEVBQUUsaUNBQWlDO0lBQ3ZDLElBQUksRUFBRSw0RkFBNEY7Q0FDbkcsQ0FBQztBQUNGLE1BQU0sOEJBQThCLEdBQTJCO0lBQzdELElBQUksRUFBRSxxS0FBcUs7SUFDM0ssWUFBWSxFQUFFLENBQUMsY0FBYyxDQUFDO0NBQy9CLENBQUM7QUFDRixNQUFNLHNCQUFzQixHQUEyQjtJQUNyRCxJQUFJLEVBQUUsK05BQStOO0lBQ3JPLFlBQVksRUFBRTtRQUNaO1lBQ0UsSUFBSSxFQUFFLGlDQUFpQztZQUN2QyxJQUFJLEVBQUUsb0hBQW9IO1NBQzNIO0tBQ0Y7Q0FDRixDQUFDO0FBQ0YsTUFBTSx5QkFBeUIsR0FBMkI7SUFDeEQsSUFBSSxFQUFFLHVKQUF1SjtJQUM3SixZQUFZLEVBQUUsQ0FBQyxjQUFjLENBQUM7Q0FDL0IsQ0FBQztBQUNGLE1BQU0sb0JBQW9CLEdBQTJCO0lBQ25ELElBQUksRUFBRSxvSEFBb0g7SUFDMUgsWUFBWSxFQUFFLENBQUMsY0FBYyxDQUFDO0NBQy9CLENBQUM7QUFDRixNQUFNLHVCQUF1QixHQUEyQjtJQUN0RCxJQUFJLEVBQUUsc0dBQXNHO0lBQzVHLFlBQVksRUFBRTtRQUNaO1lBQ0UsSUFBSSxFQUFFLGtCQUFrQjtTQUN6QjtRQUNEO1lBQ0UsSUFBSSxFQUFFLHdCQUF3QjtTQUMvQjtLQUNGO0NBQ0YsQ0FBQztBQUNGLE1BQU0sMEJBQTBCLEdBQTJCO0lBQ3pELElBQUksRUFBRSxrSkFBa0o7SUFDeEosWUFBWSxFQUFFO1FBQ1o7WUFDRSxJQUFJLEVBQUUseUJBQXlCO1lBQy9CLElBQUksRUFBRSw0RkFBNEY7U0FDbkc7S0FDRjtDQUNGLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBRztJQUNuQyxxQkFBcUIsRUFBRSw4QkFBOEI7SUFDckQsY0FBYyxFQUFFLHNCQUFzQjtJQUN0QyxpQkFBaUIsRUFBRSx5QkFBeUI7SUFDNUMsWUFBWSxFQUFFLG9CQUFvQjtJQUNsQyxjQUFjLEVBQUUsdUJBQXVCO0lBQ3ZDLGtCQUFrQixFQUFFLDBCQUEwQjtDQUMvQyxDQUFDIn0=